import { usePatient } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import {
  findReportDefinition,
  type ReportDefinition,
  ReportOfFindingsView,
  useReportSources,
} from "@/features/reports";

export const Route = createFileRoute("/patients/$patientId/_layout/reports/$reportId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { patientId, reportId } = Route.useParams();
  const definition = findReportDefinition(reportId);
  if (!definition) return <p className="text-sm text-muted-foreground">Unknown report.</p>;
  return <Report definition={definition} patientId={patientId} />;
}

function Report({ definition, patientId }: { definition: ReportDefinition; patientId: string }) {
  const sources = useReportSources(definition, patientId);
  const { patient } = usePatient(patientId);
  if (sources.status === "loading" || !patient) return null;
  if (sources.status === "empty") {
    return <p className="text-sm text-muted-foreground">This patient has no Discovery Day visits yet.</p>;
  }
  return <ReportOfFindingsView definition={definition} patient={patient} {...sources} />;
}
